import { render, staticRenderFns } from "./WordGameQuestion.vue?vue&type=template&id=db49199c"
import script from "./WordGameQuestion.vue?vue&type=script&lang=js"
export * from "./WordGameQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports